const categorySceneMap = {
    engines: 'engine',
    paintworks: 'paintwork',
    decors: 'interior',
    packages: 'packs',
    basicvehicle: 'basicvehicle',
    lastrada: 'lastrada',
};

const getPartByUid = (partUid, parts) => {
    const categories = Object.keys(parts);
    for (let i = 0; i < categories.length; i += 1) {
        if (parts[categories[i]] === null) {
            continue; // eslint-disable-line no-continue
        }
        const partsOfCategory = parts[categories[i]].data;
        const foundPart = partsOfCategory.filter((part) => part.uid === partUid);
        if (foundPart.length > 0) {
            return { ...foundPart[0], scene: categorySceneMap[categories[i]] };
        }
    }
    return null;
};

export default getPartByUid;
